import { THEMES_MAP } from './params';
export var getTheme = function getTheme(_ref) {
  var primary = _ref.primary,
      secondary = _ref.secondary,
      whiteBg = _ref.whiteBg,
      opacity = _ref.opacity,
      theme = _ref.theme;
  var attributes = {
    primary: primary,
    secondary: secondary,
    whiteBg: whiteBg,
    opacity: opacity
  };
  var themeKey = (Object.entries(attributes).find(function (entry) {
    return entry[1];
  }) || {})[0];
  return THEMES_MAP[themeKey] || theme;
};